import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import { isDirty, hasSubmitSucceeded, getFormValues } from 'redux-form';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import Prompt from 'components/common/Prompt';
import TemplatesCreateEditForm from 'components/settings/TemplatesCreateEditForm';

import { fetchTemplate } from 'redux/modules/templates';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class TemplateCreateEdit extends Component {
  componentDidMount() {
    const { actions, match, variant } = this.props;
    if (variant === 'edit') {
      actions.fetchTemplate({
        ID: match.params.id,
        triggerLoading: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { variant, loading, history } = this.props;
    if (variant === 'edit'
      && loading > 0
      && nextProps.loading === 0
      && !nextProps.initialValues) {
      history.replace('/settings/templates/');
    }
  }

  render() {
    const {
      form,
      variant,
      initialValues,
      dirty,
      history,
      loading,
      submitSucceeded,
      formValues,
    } = this.props;
    return (
      <Layout variant="settings">
        {loading > 0 ? (
          <Progress />
        ) : (
          <Fragment>
            <Helmet>
              <title>
                {appTitle} {titleSeparator} {initialValues
                  ? `Templates ${titleSeparator} ${initialValues.Name}` : 'Create Template'}
              </title>
            </Helmet>
            <TemplatesCreateEditForm
              form={form}
              variant={variant}
              {...initialValues ? { initialValues } : {}}
              onSubmitSuccess={() => {
                history.push('/settings/templates');
              }}
              onPrintPreviewButtonClick={() => {
                if (variant === 'edit') {
                  history.push(`/settings/templates/${initialValues.ID}/print`);
                } else {
                  history.push({
                    pathname: '/settings/templates/create/print',
                    state: {
                      template: formValues,
                    },
                  });
                }
              }}
              {...variant === 'create' ? {
                destroyOnUnmount: false,
                keepDirtyOnReinitialize: true,
              } : {}}
            />
            {dirty &&
              <Prompt
                when={(crntLocation, nextLocation) => {
                  if (nextLocation.pathname === '/settings/templates/create/print') {
                    return false;
                  }
                  return dirty && !submitSucceeded;
                }}
                message="All the setups will be reset. Are you sure that you want to leave this page?"
              />
            }
          </Fragment>
        )}
      </Layout>
    );
  }
}

TemplateCreateEdit.propTypes = {
  form: PropTypes.string,
  variant: PropTypes.oneOf(['create', 'edit']),
  initialValues: PropTypes.shape({
    Name: PropTypes.string,
  }),
  formValues: PropTypes.shape({
    Name: PropTypes.string,
  }),
  loading: PropTypes.number.isRequired,
  dirty: PropTypes.bool.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    state: PropTypes.shape({
      justCreated: PropTypes.bool,
    }),
  }).isRequired,
  actions: PropTypes.shape({
    fetchTemplate: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

TemplateCreateEdit.defaultProps = {
  form: 'templateCreate',
  variant: 'create',
  initialValues: null,
  formValues: {},
};

const mapStateToProps = (store, ownProps) => {
  const formValues = getFormValues(ownProps.form)(store);
  let initialValues = null;
  if (ownProps.variant === 'edit') {
    const template = store.templates.data.length > 0
      ? store.templates.data.find(item => item.ID === Number(ownProps.match.params.id))
      : null;
    initialValues = template
      ? {
        ID: template.ID,
        Name: template.Name,
        Questions: template.Questions.map(({ ID, Text, ...otherValues }) => ({
          ...Text ? { Text } : {},
          ...otherValues,
        })),
      } : null;
  } else {
    initialValues = ownProps.location.state
      ? ownProps.location.state.initialValues
      : null;
  }
  return {
    loading: store.templates.loading,
    ...initialValues
      ? {
        initialValues,
        key: initialValues.ID,
      }
      : {
        key: 'create',
      },
    formValues,
    dirty: isDirty(ownProps.form)(store),
    submitSucceeded: hasSubmitSucceeded(ownProps.form)(store),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchTemplate }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateCreateEdit);



// WEBPACK FOOTER //
// ./src/pages/settings/TemplateCreateEdit.js